module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-contact"
  }, [_c('div', {
    staticClass: "section-contact-left"
  }, [_c('div', {
    staticClass: "text-contact-header"
  }, [_vm._v(_vm._s(_vm.contact.head))])]), _vm._v(" "), _c('div', {
    staticClass: "section-contact-right"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("   E-mail : "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.contact.email
    }
  }, [_vm._v(_vm._s(_vm.contact.email))])]), _vm._v(" "), _c('p', [_vm._v("   Tel : "), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.contact.tel1
    }
  }, [_vm._v(_vm._s(_vm.contact.tel1))]), _vm._v(" " + _vm._s(_vm.contact.tel1_desc))]), _vm._v(" "), _c('p', [_vm._v("   Tel : "), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.contact.tel2
    }
  }, [_vm._v(_vm._s(_vm.contact.tel2))]), _vm._v(" " + _vm._s(_vm.contact.tel2_desc))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b7315ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/contact/components/index.vue
// module id = 588
// module chunks = 2